<ng-template #tpl>
	<ng-container *transloco="let translate">
		<div class="talign-c">
			<div class="w-100 m-1-tb">
				<img src="assets/images/core/robot-error.svg" style="height: 120px" />
				<div class="fs-xs fc-warn m-0h-t">
					@if (!!$quotaNodes()) {
						<span>
							{{ $quotaNodes()?.used || 0 }}/{{ $quotaNodes()?.total || 0 }}
						</span>
					}

					@if (!$quotaNodes()) {
						<span> &nbsp; </span>
					}
				</div>
			</div>

			<p class="fw-bold fs-icon talign-c">
				{{ translate('errorModals.chat_ai_conversations_quota.title') }}
			</p>

			<p
				class="m-1h-tb"
				[innerHTML]="translate('errorModals.chat_ai_conversations_quota.description')"
			></p>

			<button
				class="w-100 p-0t-tb p-1h-rl border-box bg-primary fw-bold fc-white"
				style="border-radius: calc(0.5 * var(--spacing))"
				(click)="confirm()"
			>
				{{ translate('errorModals.quota_common.check') }}
			</button>

			<button class="w-100 p-0t-tb p-1h-rl border-box fw-bold fc-light" (click)="cancel()">
				{{ translate('general.close') }}
			</button>
		</div>
	</ng-container>
</ng-template>
